/*
  // The in-progress device-based IF-function expression syntax's regex is built from the
  // following code:
  var inProgRegEx = (blocks) =>
    _.reverse([...blocks]).reduce((memo, block) => `(?:${block}${memo})?`, '');
  var start = '{';
  var deviceConditionBlocks = ['d', 'e', 'v', 'i', 'c', 'e', '\\s*', '=', '\\s*',
    'm', 'o', 'b', 'i', 'l', 'e'];
  var insertTextBlocks = ['((?:[^)\\\\]|\\\\\\S)*)'];
  var defaultTextBlocks = [':', '\\s*', '((?:[^{}\\\\]|\\\\\\S)*)'];
  var blocks = ['=\\s*', 'i', 'f', '\\s*', '\\(', '\\s*', `(${inProgRegEx(deviceConditionBlocks)})`,
    '\\s*', ',', '\\s*', ...insertTextBlocks, '\\)', '\\s*', `${inProgRegEx(defaultTextBlocks)}`,
    '(})'
  ];
  start + inProgRegEx(blocks);
*/
/**
 * **GENERATED REGULAR EXPRESSION!** Use the above code snippet to generate a different version.
 * Matches an in-progress device-based IF-function expression. Captures the following information:
 * [0]: whole match starting from '{=' and finishing with '}'
 * [1]: the 'i' character - mark of first significant part of the express
 * [2]: condition text, eg. 'device=mobile'
 * [3]: insert text
 * [4]: default text
 * [5]: the '}' character - mark of a complete expression
 * index: 0-based index of the whole match within the parsed string
 */
export const iffInProgressSyntax = /{(?:=\s*(?:(i)(?:f(?:\s*(?:\((?:\s*(?:((?:d(?:e(?:v(?:i(?:c(?:e(?:\s*(?:=(?:\s*(?:m(?:o(?:b(?:i(?:l(?:e)?)?)?)?)?)?)?)?)?)?)?)?)?)?)?)(?:\s*(?:,(?:\s*(?:((?:[^)\\]|\\\S)*)(?:\)(?:\s*(?:(?::(?:\s*(?:((?:[^{}\\]|\\\S)*))?)?)?(?:(}))?)?)?)?)?)?)?)?)?)?)?)?)?)?)?/i;

/*
  // The in-progress audience-based IF-function expression syntax's regex is built from the
  // following code:
  var inProgRegEx = (blocks) =>
    _.reverse([...blocks]).reduce((memo, block) => `(?:${block}${memo})?`, '');
  var normalRegEx = (blocks) =>
    _.reverse([...blocks]).reduce((memo, block) => `${block}${memo}`, '');
  var start = '{';
  var audienceInBlocks = ['a', 'u', 'd', 'i', 'e', 'n', 'c', 'e', '\\s*', 'i', 'n'];
  var audienceListBlocks = ['(?:(?:[^,)\\\\]|\\\\\\S),?)*'];
  var audienceConditionBlocks = [`(${inProgRegEx(audienceInBlocks)})`, '\\s*', '\\(',
    '\\s*', `(${normalRegEx(audienceListBlocks)})`, '\\)'];
  var insertTextBlocks = ['((?:[^)\\\\]|\\\\\\S)*)'];
  var defaultTextBlocks = [':', '\\s*', '((?:[^{}\\\\]|\\\\\\S)*)'];
  var blocks = ['=\\s*', 'i', 'f', '\\s*', '\\(', '\\s*',
    `${inProgRegEx(audienceConditionBlocks)}`, '\\s*', ',', '\\s*', ...insertTextBlocks, '\\)',
    '\\s*', `${inProgRegEx(defaultTextBlocks)}`, '(})'
  ];
  start + inProgRegEx(blocks);
*/
/**
 * **GENERATED REGULAR EXPRESSION!** Use the above code snippet to generate a different version.
 * Matches an in-progress device-based IF-function expression. Captures the following information:
 * [0]: whole match starting from '{=' and finishing with '}'
 * [1]: the 'i' character - mark of first significant part of the express
 * [2]: condition text, eg. 'audience in'
 * [3]: audience in condition body, eg. 'audience 1, audience 2'
 * [4]: insert text
 * [5]: default text
 * [6]: the '}' character - mark of a complete expression
 * index: 0-based index of the whole match within the parsed string
 */
export const iffInProgressAudienceSyntax = /{(?:=\s*(?:(i)(?:f(?:\s*(?:\((?:\s*(?:(?:((?:a(?:u(?:d(?:i(?:e(?:n(?:c(?:e(?:\s*(?:i(?:n)?)?)?)?)?)?)?)?)?)?)?)(?:\s*(?:\((?:\s*(?:((?:(?:[^,)\\]|\\\S),?)*)(?:\))?)?)?)?)?)?(?:\s*(?:,(?:\s*(?:((?:[^)\\]|\\\S)*)(?:\)(?:\s*(?:(?::(?:\s*(?:((?:[^{}\\]|\\\S)*))?)?)?(?:(}))?)?)?)?)?)?)?)?)?)?)?)?)?)?)?/i;
